var path = '/app/dashboard/templates/dashboard.accepted-quotes.html';
var html = "<wor-accepted-quotes\n  [quotes]=\"acceptedQuotes\">\n</wor-accepted-quotes>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;